(() => {
  // Preview-only corrections verified against product descriptions on 2026-09-09.
  // Tarot packaging and mineral names do not make these incense products cards or stones.
  const incenseHandles = new Set([
    'sagrada-madre-strength-marseilio-taro-smilkalai',
    'sagrada-madre-the-empress-marseilio-taro-smilkalai',
    'sagrada-madre-temperance-marseilio-taro-smilkalai',
    'sagrada-madre-the-moon-marseilio-taro-smilkalai',
    'sagrada-madre-tarot-temperance-marseilio-taro',
    'sagrada-madre-tarot-the-star-marseilio-taro',
    'sagrada-madre-india-black-enigma-spiritual-guide',
    'sagrada-madre-copal-1-vnt',
    'noor-oud-topaz',
    'sagrada-madre-juodo-turmalino-rinkinys',
    'sagrada-madre-sacred-spiritual-guide',
    'tribal-soul-white-copal',
    'sagrada-madre-copal'
  ]);
  // Reviewed product-specific corrections: preserve genuine cards, stones and gift bags.
  const typeOverrides = new Map([
    ['auksinio-obsidiano-su-metatrono-kubu','Pakabukai'],
    ['kalnu-kristolo-mala-108','Karoliai'],
    ['ametisto-mala-108','Karoliai'],
    ['8-planetu-rinkinys','Mineralai'],
    ['aksominis-maiselis-su-7-cakromis','Taro maišeliai'],
    ['ritualine-taure-pentagrama','Ritualinės taurės'],
    ['triju-skyriu-taro-kortu-dezute','Taro dėžutės'],
    ['taro-kortu-dezute-trigubas-menulis','Taro dėžutės'],
    ['taro-kilimelis-gyvybes-medis-1','Kilimėliai'],
    ['taro-kilimelis-gyvybes-medis','Kilimėliai'],
    ['taro-kilimelis-zodiakas','Kilimėliai']
  ]);
  const productType = p => typeOverrides.get(p.handle) ?? (incenseHandles.has(p.handle) ? 'Smilkalai' : (p.product_type ?? p.type ?? ''));
  function order(products, mode='default') {
    const result=[...products];
    if(mode==='default')return [...result.filter(p=>p.available),...result.filter(p=>!p.available)];
    if(mode==='price-low')result.sort((a,b)=>a.cents-b.cents);
    if(mode==='price-high')result.sort((a,b)=>b.cents-a.cents);
    if(mode==='title')result.sort((a,b)=>a.title.localeCompare(b.title,'lt'));
    return result;
  }
  function groups(products, collectionPath='') {
    const isAroma=collectionPath.replace(/\/$/,'').endsWith('/collections/kvapai-ir-ritualai');
    const ingredients=isAroma
      ? [{name:'Zodiako žvakės',field:'zodiac_candle'},{name:'Baltasis šalavijas',field:'white_sage'},{name:'Palo Santo',field:'palo_santo'}].map(g=>({...g,count:products.filter(p=>p[g.field]===true).length})).filter(g=>g.count>0)
      : [];
    if(products.length<48)return ingredients;
    const counts=new Map();
    for(const p of products){const name=isAroma&&p.candle===true?'Žvakės':p.product_type;if(name?.trim())counts.set(name,(counts.get(name)||0)+1);}
    if(counts.size<2)return ingredients;
    return [...ingredients,...[...counts].map(([name,count])=>({name,count,...(isAroma&&name==='Žvakės'?{field:'candle'}:{})})).sort((a,b)=>b.count-a.count||a.name.localeCompare(b.name,'lt'))];
  }
  function matchesGroup(product, name, groupOptions) {
    if(!name)return true;
    const definition=groupOptions.find(g=>g.name===name);
    if(definition?.field)return product[definition.field]===true;
    if(product.candle===true&&groupOptions.some(g=>g.field==='candle'))return false;
    return product.product_type===name;
  }
  const longTitle=title=>title.length>45;
  const ringGuide=p=>/(?:^|\s)žied(?:as|ai)(?:\s|$)/iu.test(p.title||'')||/^žiedai$/iu.test(p.type||'');
  const api={order,groups,matchesGroup,longTitle,ringGuide,productType};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else window.HDCatalogModel=api;
})();
